import { fork, call, put, all, takeEvery } from 'redux-saga/effects';
import asyncInterface from "../asyncInterface";
import * as actionNameTypes from "../Epics/MyAccounts/actionType";
import { getpwUrl } from "../utils/commonUtil";
import { profile } from '../services/apiServices';
import  * as actionTypes from '../actions/globalActionTypes';
import ConstVals from '../utils/constants';


export function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.recommendAnExchange.fetchAccountData(fetchPayload);
}

export function submitUserData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.recommendGrant.postCharityData(fetchPayload.payload);
}


export function* fetchAccountDataWorker(fetchPayload) {
  try {
      yield put({type:actionTypes.globalAccountDataLoadType})
    const fetchObj = fetchPayload.payload.metaData;
    const fetchUrls = fetchPayload.payload.metaData.url;
    const fetchArr = [];
    for (const key in fetchUrls) {

      if (Object.prototype.hasOwnProperty.call(fetchUrls, key)) {
        const keyObj = Object.assign({
          method: fetchObj.method,
          url: fetchUrls[key]
        });
        fetchArr.push(keyObj);
      }
    }

    const fetchedArr = yield all(
      fetchArr.map(each => call(fetchAccountData, each))
    );

    if (fetchPayload.payload.metaData.page === "recommendAnExchange") {
      console.log("rac");
      if (fetchedArr) {
        yield put({
          type: actionTypes.recommendAnExchangeDataSuccessType,
          payload: fetchedArr[0].data
        });
        yield put({
          type: actionTypes.makeRecommendFromPoolsType,
          payload: fetchedArr[0].data
        });
      }
    }

    if (fetchPayload.payload.metaData.page === "contributionsDashboard") {
      yield put({
        type: "",
        payload: fetchedArr[0].data
      })
    }

    if (fetchPayload.payload.metaData.page === "grantsDashboard") {
      yield put({
        type: "",
        payload: fetchArr[0].data
      })
    }

    if (fetchPayload.payload.metaData.page === "contributionsDashboard") {
      yield put({
        type: "",
        payload: fetchedArr[0].data
      })
    }

    if (fetchPayload.payload.metaData.page === "NPAccount") {
      yield put({
        type: actionTypes.getUserDetailsType,
        payload: fetchedArr[0].data
      });
      yield put({
        type: actionTypes.getDropdownValuesType,
        payload: fetchedArr[1].data
      });
    }

    if (fetchPayload.payload.metaData.page === "transactionSummary") {
      yield put({
        type: actionTypes.getAPIDataType,
        payload: fetchedArr[0].data
      });
    }

    if (fetchPayload.payload.metaData.page === "EditAdvisor") {
      yield put({
        type: actionTypes.getUserEditDetailsType,
        payload: fetchedArr[0].data
      });
      yield put({
        type: actionNameTypes.updateDropDownValType,
        payload: fetchedArr[1].data
      });
    }
    if (fetchPayload.payload.metaData.page === "EditProfile") {
      fetchedArr[0].data.advisors = fetchedArr[0].data.profile;
      yield put({
        type: actionTypes.getUserEditDetailsType,
        payload: fetchedArr[0].data
      });

      yield put({
        type: actionNameTypes.updateDropDownValType,
        payload: fetchedArr[1].data
      });
    }


    yield put({
      type: actionTypes.accountDataReceivedType,
      data: fetchedArr[0].data
    });
  } catch (error) {
    yield put({
      type: actionTypes.accountDataRequestFailedType,
      payload: error
    });
  }
}

export function* fetchAccountDataWatcher() {
  yield takeEvery(actionTypes.fetchAccountDataType, fetchAccountDataWorker);
}

export function* handlerServerSideErrorsGlobal({error, type = 'default', errorCodes = [500,503], isLogout = false,redirect = null,isDirectlogout = false,isRedirectfirst = false})
{
  if(errorCodes.includes(error?.response?.status) )
  {
    const popupContent = ConstVals.ERRORS.hasOwnProperty(type) ? ConstVals.ERRORS[type]: null;    
    if(popupContent) {
      yield put({
        type:actionTypes.handleServerError,
        payload:{
            title: popupContent.title,
            message: popupContent.message,
            primaryCtaLabel:"OKAY",
            isLogout,
            redirect,
            isDirectlogout,
            isRedirectfirst
        }
      })
    }
  }
}

export function* relationshipDataFetch(data) {
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.fetchRelationDropDownSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionTypes.fetchRelationDropDownFailureType,
      error
    });
  }
}
export function* fetchDropdownDataWorker(fetchPayload) {
  yield all([
    fork(relationshipDataFetch, fetchPayload.payload.metaData[0])
  ]);
}
export function* fetchDropdownDataWatcher() {
  yield takeEvery(actionTypes.fetchDropDownValType, fetchDropdownDataWorker);
}

export function* fetchSecondNavBarWorker(fetchPayload) {
  try {
    const response = yield call(fetchAccountData, fetchPayload.payload.metaData);
    yield put({
      type: actionTypes.CSRDataSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionTypes.CSRDataFailedType,
      error
    });
  }
}
export function* fetchSecondNavBarWatcher() {
  yield takeEvery(actionTypes.getCSRDataType, fetchSecondNavBarWorker);

}

export function* getCSRBusinessFunction(payload) {
  try {
    const response = yield call(fetchAccountData, payload.payload.metaData);
    yield put({ type: actionTypes.csrBusinessFunctionSuccessType, payload: response.data})
  } catch(error){
    yield put({ type: actionTypes.csrBusinessFunctionFailedType, error})
  }
}

export function* fetchCSRBusinessFunctionWatcher(){
  yield takeEvery(actionTypes.pullBusinessFunctionForCsrType, getCSRBusinessFunction)
}
// Validate step and route
export function* stepperWorker(actionObj) {
  const { stepConfig, history } = yield actionObj.payload;
  const validateSubmit = false;
}

export function* postCoachMarkWorker(fetchPayload) {
  try {
    const response = yield call(submitUserData, fetchPayload);
  } catch (error) {
  }
}

export function* logoutSessionFlushWorker(fetchPayload, frompage) {
  let userIdUpdated = sessionStorage.getItem('userIdUpdated');
  try {
    //Added if condition for unit testing purpose
    if(fetchPayload && fetchPayload.payload && fetchPayload.payload.throwError) {
      throw(new Error('error'));
    }
    // Revert to add call to revoke session token as identified part of security testing    
    yield call(submitUserData, fetchPayload);
    localStorage.clear();
    sessionStorage.clear();
    sessionStorage.setItem("hasLoggedOut", true);
    sessionStorage.setItem("fromPage", fetchPayload.payload.page);
    if (userIdUpdated) {
      sessionStorage.setItem('userIdUpdated', true);
    }
    if (fetchPayload.payload.page !== 'productTour') {
      window.location.href = getpwUrl();
      yield call(submitUserData, fetchPayload);
    }

  } catch (error) {       
    localStorage.clear();
    sessionStorage.clear();
    sessionStorage.setItem("hasLoggedOut", true);
    sessionStorage.setItem("fromPage", fetchPayload.payload.page);
    if (userIdUpdated) {
      sessionStorage.setItem('userIdUpdated', true);
    }
    if (fetchPayload.payload.page !== 'productTour') {
      window.location.href = getpwUrl();
    }
  }
}

export function* fetchadvisoryWorker(action) {
  try {
    const response = yield call(profile.getAccountAdvisors, action.payload);
    yield put({
      type:actionTypes.fetchAccountAdvisorsSuccessType,
      payload: response.data
    })
  } catch (error) {
    yield put({
      type: actionTypes.fetchAccountAdvisorsFailedType,
      error
    })
  }
}

export function* getAvailableBalanceFetch(data) {
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.getAvailableBalanceWorkerSuccessType,
      payload: response.data
    })
  } catch (error) {
    yield put({
      type: actionTypes.getAvailableBalanceWorkerFailedType,
      error
    })
  }
}
export function* getCodeValueMappingWorker(fetchPayload) {
  try {
    const response = yield call(
      fetchAccountData,
      fetchPayload.payload.metaData
    );

    yield put({
      type: actionTypes.getCodeValueMappingSucessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionTypes.getCodeValueMappingFailedType,
      error
    });
  }
}

export function* getAvailableBalanceWorker(fetchPayload) {
  yield all([fork(getAvailableBalanceFetch, fetchPayload.payload.metaData[0])]);
}

export function* stepperWatcher() {
  yield takeEvery(actionTypes.updateStepperConfigType, stepperWorker);
}

export function* fetchadvisoryWatcher() {
  yield takeEvery(actionTypes.fetchAccountAdvisorsType, fetchadvisoryWorker);
}

export function* logoutSessionFlushWatcher() {
  yield takeEvery(actionTypes.logoutSessionFlushType, logoutSessionFlushWorker);
}

export function* postCoachMarkWatcher() {
  yield takeEvery(actionTypes.postCoachMarksType, postCoachMarkWorker);
}

export function* myAccountDetailsSuccessWatcher() {
  yield takeEvery(actionTypes.fetchAccountDetailsDataType, myAccountDetailsSuccessWorker);
}

export function* myAccountDetailsSuccessWorker(fetchPayload) {
  yield put({
    type:actionTypes.accountDetailsDataSuccessLoaderType,
    payload: ""
  });
  try {
    const response = yield call(fetchAccountData,
      fetchPayload.payload.metaData
    );
    yield put({
      type: actionTypes.accountDetailsDataSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type:actionTypes.accountDetailsDataFailedType,
      error
    });
  }
}

export function* fetchUserInfoWorker(payload) {
  try {
    const response = yield call(fetchAccountData, payload.payload.metaData);
    yield put({
      type: actionTypes.fetchUserSuccessType,
      payload: response.data
    })

  } catch(error) {
    if(window.auth0 && error?.response?.status === 503) {
      window.auth0.logout({ returnTo: `${process.env.REACT_APP_DRUPAL_BASE_URL}?usererrorcode=503` });      
    } else {
      yield put({
        type: actionTypes.fetchUserInfoFailureType,
        userInfoError: error
      })
    }
    
  }
}

export function* getAvailableBalanceWatcher() {
  yield takeEvery(actionTypes.getAvailableBalanceType, getAvailableBalanceWorker);

}

export function* getCodeValueMappingWatcher() {
  yield takeEvery(actionTypes.fetchCodeValueMappingType, getCodeValueMappingWorker);
}

export function* fetchUserInfoWatcher() {
  yield takeEvery(actionTypes.fetchUserInfoType, fetchUserInfoWorker);
}

export default function* commonSagaWatcher() {
  yield all([
    fork(fetchAccountDataWatcher),
    fork(postCoachMarkWatcher),
    fork(myAccountDetailsSuccessWatcher),
    fork(fetchSecondNavBarWatcher),
    fork(fetchadvisoryWatcher),
    fork(fetchadvisoryWatcher),
    fork(getAvailableBalanceWatcher),
    fork(getCodeValueMappingWatcher),
    fork(fetchCSRBusinessFunctionWatcher),
    fork(fetchUserInfoWatcher),
    fork(logoutSessionFlushWatcher),
    fork(fetchDropdownDataWatcher)
  ]);
}
